// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchBoundingBox {
    margin-left: -10px;
    height: 150px;
    width: 102% !important;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

@media only screen and (min-device-height: 650px) and (max-width: 842px) {
    .searchBoundingBox {
        width: 106% !important;
    }
}

.searchTitle {
    margin-left: 20px !important;
    height: fit-content;
}

.searchForm {
    width: 100%;
    background-color: #00338e0a;
    padding: 25px;
}

.searchBoxLabel {
    max-width: fit-content;
}

.searchPageUsername {
    margin-left: auto !important;
    margin-right: 20px !important;
}
.searchPageLogoutSection {
    padding-right: 40px !important;
}

.searchBoxInput {
    min-width: 50%;
    background-color: #FFFFFF;
}

.mrnSearchControls {
    margin-left: 20px !important;
}

@media (max-width: 768px) {
    .btn {
      font-size:11px;
      padding:4px 6px;
    }
}


.dividerLine {
    color:"#B2B2B2";
    position: "absolute";
    margin-left: "23.88px";
    margin-top: "583.97px";
    height: "0px";
    width: "479.02px";
    border: "1px";
}

.linkedRecordModalDividerLine {
    color:"#CCCCCC";
    position: "absolute";
    height: "0px";
    width: "412px";
    border: "1px";
}

.searchOutputSpacer {
    height: 60px;
}
.searchPageDefaultText {
    margin-top: 60px !important;
    margin-left: 28px !important;
    font-weight: 400 !important;
    color: #212121 !important;
    font-size: 24px !important;
}

.searchOutputBodyPlaceholder {
    text-align: center;
    margin-top: 60px !important;
}

.leftSearchResultsBlock {
    margin: 0 20px !important;
    min-height: 160px;
}

.leftSearchResultsButtons {
    margin: 0 20px !important;
    min-height: 32px;
}

.rightSearchResultsBlock {
    margin: 0 16px !important;
    min-height: 160px;
}

.verifiedCheckmark {
    margin: 4px 2px 0 !important;
    min-height: 34px;
}

.verifiedExclamationPoint {
    margin: 4px 2px 0 !important;
    height: 34px;
}

.verifiedText {
    margin-top: 5px !important;
    height: 34px;
}

.notVerifiedText {
    margin: 5px 0 0 !important;
    height: 34px;
}

.emailComponentTitle {
    margin-right: 4px !important;
    min-height: 34px;
}

.identityComponentTitle {
    height: 34px;
}

.temporaryPasswordTextField {
    margin: 0 10px ;
    color: #084897
}

.searchResultTitle {
    margin: 0 8px !important;
}

.emailUserName {
    margin: 0px 0 16px !important;
}

.identityUserName {
    margin: 0px 0 36px !important;
}

.searchResultButtonSpacer {
    height: 24px;
}

.verificationInfo {
    padding: 4px 0 0px !important;
    margin-bottom: 28px !important;
}

.regionDropDownMessage {
    margin: 60px 0px 10px !important;
    padding-left: 20px !important;
    color: #212121;
}

.cardMargin{
    margin-top: "15px";
    margin-left: "30px";
    margin-bottom: "10px";
}

.searchMetadata{
    margin: 60px 0px 0px !important;
}

.searchMetadataCTA{
    margin: 10px 0px 40px !important;
}

.accountDetailsHeader{
    font-size: 12px;
    line-height: 20px;
    text-overflow: ellipsis;
    max-width: 200px;
}

.accountDetailsValue{
    font-size: 14px;
    font-weight: 600 !important;
    line-height: 16px;
    text-overflow: ellipsis;
    max-width: 200px;
}
.signInName{
    font-size: 14px;
    font-weight: 600 !important;
    line-height: 16px;
    text-overflow: ellipsis;
    max-width: 400px;
    margin-bottom: 8px !important;
}

.mfaDetailsValue{
    font-size: 12px;
    line-height: 20px;
    text-overflow: ellipsis;
    max-width: 300px;
}
.mfaStatusHeader{
    font-size: 14px;
    font-weight: 600 !important;
    line-height: 16px;
    text-overflow: ellipsis;
    max-width: 250px;
}

.accountDetailsHelmet {
    font-size: 14px;
    padding: 1px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    min-width: 35px;
    font-weight: 600 !important;
}

.accountDetailsMRN {
    font-size: 14px;
    padding: 1px;
    padding-left: 3px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    font-weight: 400 !important;
}

.linkedRecordResultsBlock {
    margin: 0 20px !important;
    min-height: 160px;
}

.linkedRecordResultsTitle {
    margin: 4px 16px 0px !important;
    height: 10px;
}

.linkedRecordResultsSpacer {
    height: 24px;
}

.linkedRecordBox {
    border: 1px solid #979797;
    border-radius: 14px;
    height: 212px;
    margin-left: 8px !important;
    margin-right: 8px !important;
    margin-bottom: 16px !important;
}

.linkedRecordHelmet {
    height: 32px;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
}

.linkedRecordHelmetRegion {
    height: 35px;
    border: 1px solid;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
}

.linkedRecordBoxHeader {
    margin-left: 12px !important;
    color: #000000 !important;
}
/* .linkedRecordContainer{
    max-Width: "420px" !important;
    min-Width: "420px" !important;
    margin-Right: "40px" !important;
    margin-Bottom:"20px" !important
} */
.linkIdentifierText {
    margin-left: 12px !important;
}

.linkNameText {
    margin-left: 12px !important;
}

.mrnSearchResults {
    height: 80px;
    margin-bottom: 15.5px !important;
    margin-left: 24px !important;
}

.linkedRecordRemoveButton {
    margin-left: 12px !important;
}

.MuiAccordion-root.MuiPaper-elevation1 {
    max-width: 200px;
    box-shadow: none;
}

.MuiAccordionSummary-root {
    margin-top: -15px !important;
    padding: 0px !important;
}

.MuiAccordionSummary-expandIcon.MuiIconButton-edgeEnd {
    margin-right: 35px ;
}

.MuiAccordionDetails-root {
    padding: 0px !important;
}

.MuiCollapse-container {
    margin-top: -20px !important;
}

.MuiAccordionSummary-root.Mui-expanded {
    min-height: 43px !important;
}

.MuiAccordionSummary-content {
    margin: 0 !important;
    margin-top: 0px !important;
}
.MuiIconButton-root{
    padding: 0px !important;
}
.mt5 {
    margin-top: 5px !important;
}
.mt3 {
    margin-top: 3px !important;
}
.mt10 {
    margin-top: 10px !important;
}
.mt20 {
    margin-top: 20px !important;
}
.mt30 {
    margin-top: 30px !important;
}
.mt40 {
    margin-top: 40px !important;
}
.ml40 {
    margin-left: 40px !important;
}
.mt-7{
    margin-top: -7px !important;
}
.ml20 {
    margin-left: 20px !important;
}
.ml5 {
    margin-left: 5px !important;
}
.mlt20 {
    margin-left: 20px !important;
    margin-top: 20px !important;
}
.mb9 {
    margin-bottom: 9px !important;
}
.mb10 {
    margin-bottom: 10px !important;
}
.mb30 {
    margin-bottom: 30px !important;
}
.ssnComponent {
    min-height: 50px !important;
}
.mt10 {
    margin-top: 10px !important;
}
.mt15 {
    margin-top: 10px !important;
}
.mb30 {
    margin-bottom: 30px !important;
}
.ml40 {
    margin-left: 40px !important;
}
.cardHeader {
    margin: 15px 30px 10px !important;
    width: calc(100% - 60px) !important;
}
.mr10 {
    margin-right: 10px !important;
}
.mw200{
    min-width: 200px;
}
.myChartName {
    min-height:43px !important; margin-bottom: 9px !important;
}
.unLink {
    margin-bottom: 9px !important; max-width: 63px !important;
}
.normalCard {
    margin-top: 15px !important; margin-left: 30px !important; margin-bottom: 10px !important;
}
.mrnRegion {
    margin-left: 15px !important;
    font-weight: 600 !important;
}
.boldText {
    font-weight: bold !important;
}
.createAccountCTA {
    margin-left: 20px !important;
    margin-top: 20px !important;
    margin-bottom: 40px !important;
}
.searchMessage {
    font-style: italic !important;
    font-weight: 500 !important;
}
.cardContainer{
    max-width: "500px";
    min-width: "500px";
    margin-Bottom:"20px";
    margin-Right:"20px"
}
.accountAuthMessage {
    font-style: italic !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    line-height: 16px !important;
    margin-bottom: 20px !important;
    margin-top: 15px !important;
}
.minWidth150{
    min-width: 150px !important;
}
.MuiButton-root{
    min-width: 160px !important;
}
.ssnComponent {
    min-height: 50px !important;
}
.makeStyles-containedSecondary-5 {
    width: 180px !important;
}
.resetConfirmationMesssage{
    display: flex !important;
    font-size: 14px;
    font-weight: 600 !important;
    line-height: 16px;
    text-overflow: ellipsis;
}
.tempPasswordErrorMessage{
    margin-top: 10px !important;
    max-width: 60% !important;
}

.accountAuthItem {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;MACE,cAAc;MACd,eAAe;IACjB;AACJ;;;AAGA;IACI,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,2BAA2B;IAC3B,8BAA8B;IAC9B,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;;;;;GAKG;AACH;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;AAC9B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,8BAA8B;AAClC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,iCAAiC;IACjC,mCAAmC;AACvC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,0BAA0B,EAAE,6BAA6B;AAC7D;AACA;IACI,6BAA6B,EAAE,0BAA0B;AAC7D;AACA;IACI,2BAA2B,EAAE,4BAA4B,EAAE,8BAA8B;AAC7F;AACA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,8BAA8B;AAClC;AACA;IACI,6BAA6B;IAC7B,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;AACA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,wBAAwB;IACxB,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf","sourcesContent":[".searchBoundingBox {\n    margin-left: -10px;\n    height: 150px;\n    width: 102% !important;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n}\n\n@media only screen and (min-device-height: 650px) and (max-width: 842px) {\n    .searchBoundingBox {\n        width: 106% !important;\n    }\n}\n\n.searchTitle {\n    margin-left: 20px !important;\n    height: fit-content;\n}\n\n.searchForm {\n    width: 100%;\n    background-color: #00338e0a;\n    padding: 25px;\n}\n\n.searchBoxLabel {\n    max-width: fit-content;\n}\n\n.searchPageUsername {\n    margin-left: auto !important;\n    margin-right: 20px !important;\n}\n.searchPageLogoutSection {\n    padding-right: 40px !important;\n}\n\n.searchBoxInput {\n    min-width: 50%;\n    background-color: #FFFFFF;\n}\n\n.mrnSearchControls {\n    margin-left: 20px !important;\n}\n\n@media (max-width: 768px) {\n    .btn {\n      font-size:11px;\n      padding:4px 6px;\n    }\n}\n\n\n.dividerLine {\n    color:\"#B2B2B2\";\n    position: \"absolute\";\n    margin-left: \"23.88px\";\n    margin-top: \"583.97px\";\n    height: \"0px\";\n    width: \"479.02px\";\n    border: \"1px\";\n}\n\n.linkedRecordModalDividerLine {\n    color:\"#CCCCCC\";\n    position: \"absolute\";\n    height: \"0px\";\n    width: \"412px\";\n    border: \"1px\";\n}\n\n.searchOutputSpacer {\n    height: 60px;\n}\n.searchPageDefaultText {\n    margin-top: 60px !important;\n    margin-left: 28px !important;\n    font-weight: 400 !important;\n    color: #212121 !important;\n    font-size: 24px !important;\n}\n\n.searchOutputBodyPlaceholder {\n    text-align: center;\n    margin-top: 60px !important;\n}\n\n.leftSearchResultsBlock {\n    margin: 0 20px !important;\n    min-height: 160px;\n}\n\n.leftSearchResultsButtons {\n    margin: 0 20px !important;\n    min-height: 32px;\n}\n\n.rightSearchResultsBlock {\n    margin: 0 16px !important;\n    min-height: 160px;\n}\n\n.verifiedCheckmark {\n    margin: 4px 2px 0 !important;\n    min-height: 34px;\n}\n\n.verifiedExclamationPoint {\n    margin: 4px 2px 0 !important;\n    height: 34px;\n}\n\n.verifiedText {\n    margin-top: 5px !important;\n    height: 34px;\n}\n\n.notVerifiedText {\n    margin: 5px 0 0 !important;\n    height: 34px;\n}\n\n.emailComponentTitle {\n    margin-right: 4px !important;\n    min-height: 34px;\n}\n\n.identityComponentTitle {\n    height: 34px;\n}\n\n.temporaryPasswordTextField {\n    margin: 0 10px ;\n    color: #084897\n}\n\n.searchResultTitle {\n    margin: 0 8px !important;\n}\n\n.emailUserName {\n    margin: 0px 0 16px !important;\n}\n\n.identityUserName {\n    margin: 0px 0 36px !important;\n}\n\n.searchResultButtonSpacer {\n    height: 24px;\n}\n\n.verificationInfo {\n    padding: 4px 0 0px !important;\n    margin-bottom: 28px !important;\n}\n\n.regionDropDownMessage {\n    margin: 60px 0px 10px !important;\n    padding-left: 20px !important;\n    color: #212121;\n}\n\n.cardMargin{\n    margin-top: \"15px\";\n    margin-left: \"30px\";\n    margin-bottom: \"10px\";\n}\n\n.searchMetadata{\n    margin: 60px 0px 0px !important;\n}\n\n.searchMetadataCTA{\n    margin: 10px 0px 40px !important;\n}\n\n.accountDetailsHeader{\n    font-size: 12px;\n    line-height: 20px;\n    text-overflow: ellipsis;\n    max-width: 200px;\n}\n\n.accountDetailsValue{\n    font-size: 14px;\n    font-weight: 600 !important;\n    line-height: 16px;\n    text-overflow: ellipsis;\n    max-width: 200px;\n}\n.signInName{\n    font-size: 14px;\n    font-weight: 600 !important;\n    line-height: 16px;\n    text-overflow: ellipsis;\n    max-width: 400px;\n    margin-bottom: 8px !important;\n}\n\n.mfaDetailsValue{\n    font-size: 12px;\n    line-height: 20px;\n    text-overflow: ellipsis;\n    max-width: 300px;\n}\n.mfaStatusHeader{\n    font-size: 14px;\n    font-weight: 600 !important;\n    line-height: 16px;\n    text-overflow: ellipsis;\n    max-width: 250px;\n}\n\n.accountDetailsHelmet {\n    font-size: 14px;\n    padding: 1px;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    min-width: 35px;\n    font-weight: 600 !important;\n}\n\n.accountDetailsMRN {\n    font-size: 14px;\n    padding: 1px;\n    padding-left: 3px;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    font-weight: 400 !important;\n}\n\n.linkedRecordResultsBlock {\n    margin: 0 20px !important;\n    min-height: 160px;\n}\n\n.linkedRecordResultsTitle {\n    margin: 4px 16px 0px !important;\n    height: 10px;\n}\n\n.linkedRecordResultsSpacer {\n    height: 24px;\n}\n\n.linkedRecordBox {\n    border: 1px solid #979797;\n    border-radius: 14px;\n    height: 212px;\n    margin-left: 8px !important;\n    margin-right: 8px !important;\n    margin-bottom: 16px !important;\n}\n\n.linkedRecordHelmet {\n    height: 32px;\n    border-top-left-radius: 14px;\n    border-top-right-radius: 14px;\n}\n\n.linkedRecordHelmetRegion {\n    height: 35px;\n    border: 1px solid;\n    border-top-left-radius: 14px;\n    border-top-right-radius: 14px;\n}\n\n.linkedRecordBoxHeader {\n    margin-left: 12px !important;\n    color: #000000 !important;\n}\n/* .linkedRecordContainer{\n    max-Width: \"420px\" !important;\n    min-Width: \"420px\" !important;\n    margin-Right: \"40px\" !important;\n    margin-Bottom:\"20px\" !important\n} */\n.linkIdentifierText {\n    margin-left: 12px !important;\n}\n\n.linkNameText {\n    margin-left: 12px !important;\n}\n\n.mrnSearchResults {\n    height: 80px;\n    margin-bottom: 15.5px !important;\n    margin-left: 24px !important;\n}\n\n.linkedRecordRemoveButton {\n    margin-left: 12px !important;\n}\n\n.MuiAccordion-root.MuiPaper-elevation1 {\n    max-width: 200px;\n    box-shadow: none;\n}\n\n.MuiAccordionSummary-root {\n    margin-top: -15px !important;\n    padding: 0px !important;\n}\n\n.MuiAccordionSummary-expandIcon.MuiIconButton-edgeEnd {\n    margin-right: 35px ;\n}\n\n.MuiAccordionDetails-root {\n    padding: 0px !important;\n}\n\n.MuiCollapse-container {\n    margin-top: -20px !important;\n}\n\n.MuiAccordionSummary-root.Mui-expanded {\n    min-height: 43px !important;\n}\n\n.MuiAccordionSummary-content {\n    margin: 0 !important;\n    margin-top: 0px !important;\n}\n.MuiIconButton-root{\n    padding: 0px !important;\n}\n.mt5 {\n    margin-top: 5px !important;\n}\n.mt3 {\n    margin-top: 3px !important;\n}\n.mt10 {\n    margin-top: 10px !important;\n}\n.mt20 {\n    margin-top: 20px !important;\n}\n.mt30 {\n    margin-top: 30px !important;\n}\n.mt40 {\n    margin-top: 40px !important;\n}\n.ml40 {\n    margin-left: 40px !important;\n}\n.mt-7{\n    margin-top: -7px !important;\n}\n.ml20 {\n    margin-left: 20px !important;\n}\n.ml5 {\n    margin-left: 5px !important;\n}\n.mlt20 {\n    margin-left: 20px !important;\n    margin-top: 20px !important;\n}\n.mb9 {\n    margin-bottom: 9px !important;\n}\n.mb10 {\n    margin-bottom: 10px !important;\n}\n.mb30 {\n    margin-bottom: 30px !important;\n}\n.ssnComponent {\n    min-height: 50px !important;\n}\n.mt10 {\n    margin-top: 10px !important;\n}\n.mt15 {\n    margin-top: 10px !important;\n}\n.mb30 {\n    margin-bottom: 30px !important;\n}\n.ml40 {\n    margin-left: 40px !important;\n}\n.cardHeader {\n    margin: 15px 30px 10px !important;\n    width: calc(100% - 60px) !important;\n}\n.mr10 {\n    margin-right: 10px !important;\n}\n.mw200{\n    min-width: 200px;\n}\n.myChartName {\n    min-height:43px !important; margin-bottom: 9px !important;\n}\n.unLink {\n    margin-bottom: 9px !important; max-width: 63px !important;\n}\n.normalCard {\n    margin-top: 15px !important; margin-left: 30px !important; margin-bottom: 10px !important;\n}\n.mrnRegion {\n    margin-left: 15px !important;\n    font-weight: 600 !important;\n}\n.boldText {\n    font-weight: bold !important;\n}\n.createAccountCTA {\n    margin-left: 20px !important;\n    margin-top: 20px !important;\n    margin-bottom: 40px !important;\n}\n.searchMessage {\n    font-style: italic !important;\n    font-weight: 500 !important;\n}\n.cardContainer{\n    max-width: \"500px\";\n    min-width: \"500px\";\n    margin-Bottom:\"20px\";\n    margin-Right:\"20px\"\n}\n.accountAuthMessage {\n    font-style: italic !important;\n    font-weight: 500 !important;\n    font-size: 14px !important;\n    line-height: 16px !important;\n    margin-bottom: 20px !important;\n    margin-top: 15px !important;\n}\n.minWidth150{\n    min-width: 150px !important;\n}\n.MuiButton-root{\n    min-width: 160px !important;\n}\n.ssnComponent {\n    min-height: 50px !important;\n}\n.makeStyles-containedSecondary-5 {\n    width: 180px !important;\n}\n.resetConfirmationMesssage{\n    display: flex !important;\n    font-size: 14px;\n    font-weight: 600 !important;\n    line-height: 16px;\n    text-overflow: ellipsis;\n}\n.tempPasswordErrorMessage{\n    margin-top: 10px !important;\n    max-width: 60% !important;\n}\n\n.accountAuthItem {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
